import { FilterPipe } from './pipes/filter.pipe';
import { FormatIdPipe } from './pipes/format-id.pipe';
import { HumanizePipe } from './pipes/humanize.pipe';

export const SharedPipes = [FilterPipe, HumanizePipe, FormatIdPipe];
